import get from 'lodash.get';

import { ResetStateAction } from '../auth/types';
import {
    SprayedEntitiesByDateState,
    SprayedEntitiesByDateActions
} from './types';
import { SPRAYED_ENTITIES_BY_DATE_SET } from './constants';
import { RESET_STATE } from '../auth/constants';

const initialState: SprayedEntitiesByDateState = {};

export default function (
    state: SprayedEntitiesByDateState = initialState,
    action: SprayedEntitiesByDateActions | ResetStateAction
): SprayedEntitiesByDateState {
    switch (action.type) {
        case SPRAYED_ENTITIES_BY_DATE_SET:
            return get(action, 'payload', {});
        case RESET_STATE:
            return initialState;
        default:
            return state;
    }
}
